<!-- Sidebar user (optional) -->
<div class="user-panel mt-3 pb-3 mb-3 d-flex">
    <div class="image">
      <img src="assets/img/avatar1.png" class="img-circle elevation-2" alt="">
    </div>
    <div class="info">
      <a href="#" class="d-block">Ricardo Rivera</a>
    </div>
  </div>
